import { z } from 'zod';

export const InitialLoginResponseSchema = z.object({
  access_token: z.string(),
  token_type: z.string(),
});

export type InitialLoginResponse = z.infer<typeof InitialLoginResponseSchema>;

export const LoginResponseSchema = InitialLoginResponseSchema.extend({
  refresh_token: z.string(),
});

export type LoginResponse = z.infer<typeof LoginResponseSchema>;

export const SendOTPResponseSchema = z.object({
  message: z.string(),
  retries: z.number(),
  label: z.string(),
  digitCount: z.number(),
});

export type SendOTPResponse = z.infer<typeof SendOTPResponseSchema>;

const services = z
  .object({
    serviceType: z.string(),
    offer: z.object({
      id: z.number(),
      features: z.object({
        onePlanUpgradeEligiblity: z.boolean().optional(),
      }),
    }),
    service: z.object({
      provider: z.string().nullable(),
      locationId: z.string().nullable(),
    }),
  })
  .array();

export type UserService = z.infer<typeof services>;

export const MeResponseSchema = z.object({
  individual: z.object({
    firstName: z.string(),
    lastName: z.string(),
  }),
  services: services,
});

export type MeResponse = z.infer<typeof MeResponseSchema>;
